export default __webpack_public_path__ + "static/media/cdrskillassessment.b3374a36.png";